import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=5c9b1f5e"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports